<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Promotions
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-index' })">
            <i class="fa fa-gift"></i> Promotions
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-bin-index' })">
            <i class="fa fa-bank"></i> BIN
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="box-title">
            <h3>{{ title }}</h3>
          </div>
        </div>

        <div class="box-body" style="overflow: visible;">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-10">
              <div class="form-horizontal">

                <div class="form-group">
                  <label for="promo-config"
                    class="col-sm-3 control-label">
                    Promo Payment <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      id="promo-config"
                      v-model="form.config"
                      :options="promoConfigs">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-code"
                    class="col-sm-3 control-label">
                    Promo Codes <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      id="promo-code"
                      v-model="form.code"
                      :options="promoCodes">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-config-bin"
                    class="col-sm-3 control-label">
                    Promo BINs <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select multiple
                      id="promo-config-bin"
                      v-model="form.bin"
                      :options="promoBins">
                    </v-select>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <button class="btn btn-info pull-right"
            @click="submit">
            <template v-if="isCreate">Create</template>
            <template v-else>Update</template>
          </button>

          <a class="btn btn-default"
            @click.prevent="cancel">
            Cancel
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { X_API_KEY_V2, API_BASEURL_V2, X_SECRET_KEY_V2 } from '@/config';
import Common from '@/mixins/Common';
import SHA256 from 'crypto-js/sha256';

export default {
  name: 'PromoBinForm',

  mixins: [Common],

  data() {
    return {
      title: 'Create Promo BIN',
      form: {
        config: null,
        code: null,
        bin: null,
        isEnabled: null,
      },

      promoConfigs: [],
      promoBins: [],
      promoCodes: [],
      statuses: [
        {
          label: 'Active',
          value: 1,
        },
        {
          label: 'Inactive',
          value: 0,
        },
      ],
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    getPromoConfigs() {
      return new Promise((resolve, reject) => {
        this.axios.get('/promoconfigs')
          .then((response) => {
            const { data } = response.data;
            data.forEach((item) => {
              this.promoConfigs.push({
                label: item.name,
                value: item.id,
              });
            });
            resolve('getPromoConfigs done');
          })
          .catch((error) => {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available promo configs',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.getPromoConfigs();
              }
            });
            reject(error);
          });
        });
    },

    getPromoCodes() {
      return new Promise((resolve, reject) => {
        this.axios.get('/promo-code')
          .then((response) => {
            const { data } = response.data;
            data.forEach((item) => {
              this.promoCodes.push({
                label: item.code,
                value: item.code,
              });
            });
            resolve('getPromoCodes done');
          })
          .catch((error) => {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available promo codes',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.getPromoCodes();
              }
            });
            reject(error);
          });
        });
    },
    getTimestamp() {
      return new Promise((resolve) => {
        this.axios.get('/generals/get-timestamp', {
          baseURL: API_BASEURL_V2,
        })
          .then(response => resolve(response.data.data.timestamp))
          .catch(() => resolve(moment().unix()));
      });
    },
    createToken(timestamp) {
      return {
        time: timestamp,
        token: SHA256(X_SECRET_KEY_V2 + timestamp).toString(),
      };
    },
    async getPromoBins() {
      const timestamp = await this.getTimestamp();
      const { time, token } = this.createToken(timestamp);

      return new Promise((resolve, reject) => {
        const config = {
          baseURL: API_BASEURL_V2,
          headers: {
            'Accept-Language': 'id',
            'X-Api-Key': X_API_KEY_V2,
            'X-Platform': 'web',
            'X-Payment-Token': token,
            'X-Request-Time': time,
          },
        };

        this.axios.get('/bins-active', config)
          .then((response) => {
            const { data } = response.data;
            data.forEach((item) => {
              if (item.is_enabled) {
                  this.promoBins.push({
                  label: `${item.bin} - ${item.bank_name}`,
                  value: item.bin,
                });
              }
            });
            resolve('getPromoBins done');
          })
          .catch((error) => {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available promo bins',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.getPromoBins();
              }
            });
            reject(error);
          });
      });
    },

    fetch() {
      return new Promise((resolve, reject) => {
        this.axios.get(`/promobins/${this.$route.params.id}`)
          .then((response) => {
            const { data } = response.data;

            let configData = null;
            this.promoConfigs.forEach((item) => {
              if (item.value === data.promo_config_id) {
                configData = item;
              }
            });

            const codeData = [];
            data.code.forEach((itemData) => {
              this.promoCodes.forEach((item) => {
                if (item.value === itemData) {
                  codeData.push(item);
                }
              });
            });

            const binData = [];
            data.bin.forEach((itemData) => {
              this.promoBins.forEach((item) => {
                if (item.value === itemData) {
                  binData.push(item);
                }
              });
            });

            let enabled = null;
            this.statuses.forEach((item) => {
              if (item.value === data.is_enabled) {
                enabled = item;
              }
            });

            this.form.config = configData;
            this.form.code = codeData;
            this.form.bin = binData;
            this.form.isEnabled = enabled;

            resolve('Fetch done');
          })
          .catch((error) => {
            if (error.response) {
              this.errors = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: 'Failed to fetch promo code detail',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetch();
                }
              });
            }

            reject('error', error);
          });
      });
    },

    prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      const isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      const values = [];
      arr.forEach((item) => {
        values.push(item.value);
      });

      return values;
    },

    validate() {
      if (!this.form.config) {
        this.$swal('Promo payment required', 'Please select active promo', 'warning');
        return false;
      }

      if (!this.form.code || this.form.code.length < 1) {
        this.$swal('Promo code required', 'Please select at least 1 active promo code', 'warning');
        return false;
      }

      if (!this.form.bin || this.form.bin.length < 1) {
        this.$swal('Promo BIN required', 'Please select at least 1 active promo BIN', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    create() {
      const codeData = this.prepareValues(this.form.code);
      const binData = this.prepareValues(this.form.bin);

      const data = {
        promo_config_id: this.form.config.value.toString(),
        bin: JSON.stringify(binData),
        promo_code: JSON.stringify(codeData),
        is_enabled: parseInt(1, 10),
      };

      return this.axios.post('/promobins', this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'created',
            text: 'Promo Bin has been created.',
            type: 'success',
            timer: 3000,
          });

          this.$router.push({ name: 'promo-bin-index' });
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Create Failed!',
              text: 'Failed to create new Promo BIN',
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    update() {
      const codeData = this.prepareValues(this.form.code);
      const binData = this.prepareValues(this.form.bin);

      const data = {
        promo_config_id: this.form.config.value.toString(),
        bin: JSON.stringify(binData),
        promo_code: JSON.stringify(codeData),
      };

      this.axios.post('/promobins', this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'Updated',
            text: 'Promo BIN has been updated.',
            type: 'success',
            timer: 3000,
          });

          this.$router.push({ name: 'promo-bin-index' });
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed',
              text: `Promo BIN update failed. ${error}`,
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    cancel() {
      this.$router.go(-1);
    },

    async init() {
      await this.getPromoConfigs();
      await this.getPromoCodes();
      await this.getPromoBins();

      if (!this.isCreate) {
        this.title = 'Edit Promo BIN';
        await this.fetch();
      }
    },
  },

  created() {
    this.init();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/promo/bin/Form.vue